import { MultiSelect, MultiSelectProps } from '@mantine/core';

import { useGetGoodfellowQuery } from '@api/goodfellow.api';
import { uniqueByName } from '@utils/strings';

export default function GoodfellowSelector(props: MultiSelectProps) {
  const { data = [], isLoading } = useGetGoodfellowQuery();

  return (
    <MultiSelect
      label="Goodfellow"
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : 'Seleziona i Goodfellow'
      }
      data={uniqueByName(data).map((goodfellow) => ({
        label: goodfellow.name,
        value: goodfellow.name,
      }))}
      disabled={isLoading}
      {...props}
    />
  );
}
